/* istanbul ignore file -- production store bootstrap wrapper around easy-peasy store creation */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import { createStore } from 'easy-peasy';

import reducer from '../reducers';
import { sentryBreadcrumbMiddleware } from '../utils/log';

const makeStore = () =>
  createStore(reducer, {
    middleware: [sentryBreadcrumbMiddleware],
    name: 'Ouster Data App [Prod]',
    devTools: false,
  });

export default makeStore;
